import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, LockIcon, CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, CTA_LABEL, OFFER } from '../data/checkout';
import { trackCheckout } from '../utils/tracking';
const includes = ['I 6 volumi completi di metodologia della ricerca', 'I 5 bonus strategici', 'Formato PDF pronto da utilizzare', 'Garanzia totale di 7 giorni'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-black relative" data-id="element-173" data-mp="1s9dfk72nhbux">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-174" data-mp="1sbq6h9qdywk4" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-175" data-mp="226i4genvrlff">
        <div className="text-center mb-10" data-id="element-176" data-mp="2up6oft9qc1n">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-177" data-mp="2w0h2yh7yi1q">
            Il tuo accesso a Metodologia della Ricerca Pro
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-178" data-mp="1mgofre9i7flx">
            Accesso immediato · Pagamento in euro
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-dark-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-179" data-mp="1howvflgxy648">
          <p className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs whitespace-nowrap" data-id="element-180" data-mp="20gfzzwqm5s8d">
            🏆 Offerta principale
          </p>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-181" data-mp="1repxnvv718vt">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-182" data-mp="k2phvm2nt3fq">
              Metodologia della Ricerca Pro
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-183" data-mp="g2p483ndww9q">
              I 6 volumi + 5 bonus strategici pronti da utilizzare da oggi.
            </p>

            <ul className="text-left max-w-sm mx-auto space-y-2 mb-8 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-184" data-mp="mh4g3jcuy6q9">
              {includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-185" data-mp="7ly7comdntt8">
                  <CheckIcon size={16} className="text-gold shrink-0 mt-0.5" aria-hidden="true" data-id="element-186" data-mp="3uweas6ef49o0" />
                  <span data-id="element-187" data-mp="3kyqjjqg0tkal">{item}</span>
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-188" data-mp="3pxkzmkmlsur0">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-189" data-mp="3pymnjpopxbq5">
                {OFFER.comparePriceLabel}
              </span>
              <p className="flex items-baseline justify-center gap-2" data-id="element-190" data-mp="3bzwoi4ic91z5">
                <span className="text-2xl md:text-3xl text-white" data-id="element-191" data-mp="3fy3xgd6k8yzs">Oggi:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold font-sans" data-id="element-192" data-mp="2xabk1udtmzut">
                  {OFFER.priceLabel}
                </span>
              </p>
            </div>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-193" data-mp="36bjchvtnp6gz">
              {CTA_LABEL}
            </Button>

            <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400 mb-5" data-id="element-194" data-mp="3g7usavsggeg6">
              <li className="flex items-center gap-1.5" data-id="element-195" data-mp="3b91qi0mj6bvu">
                <LockIcon size={12} className="text-gold" aria-hidden="true" data-id="element-196" data-mp="3p0zgwu8gpj2o" />{' '}
                Pagamento sicuro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-197" data-mp="3l2s9wr3svw4o">
                <ZapIcon size={12} className="text-gold" aria-hidden="true" data-id="element-198" data-mp="2w46d5oefh14" />{' '}
                Accesso immediato
              </li>
              <li className="flex items-center gap-1.5" data-id="element-199" data-mp="3tz9d985xappv">
                <ShieldIcon size={12} className="text-gold" aria-hidden="true" data-id="element-200" data-mp="hx1act92vci0" />{' '}
                Garanzia di 7 giorni
              </li>
            </ul>

            <p className="text-[11px] text-gray-400" data-id="element-201" data-mp="lxbiockcef01">
              Pagamento unico. Nessun abbonamento.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}